import { Component, SimpleChanges, ViewChild,  ChangeDetectorRef, EventEmitter } from '@angular/core';
import { MessageService } from 'base';
import { CustomSnmpDevicesComponent, CustomSnmpSettingsComponent, MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { MonitorEditorComponentBase } from '../MonitorEditorComponentBase';
import { MonitorScheduleComponent } from '../monitorschedule/monitorschedule.component';
import { MonitorEventsComponent } from '../monitorevents/monitorevents.component';
import { MonitorHistoryComponent } from '../monitorhistory/monitorhistory.component';
import { NavigationService } from 'netview';
import { Dictionary, Schedule } from 'DiscoveryEngine.TS/Utils';
import { SnmpMonitorEntry } from '../../../DiscoveryEngine.TS/Monitors';


export class CustomSnmpMonitorComponentState {

	public deviceCache: Object;
	public stateCache: Object;
	public deviceCacheChange: EventEmitter<any>;
	public stateCacheChange: EventEmitter<any>;
	public settingsChange: EventEmitter<any>;

	constructor() {
		this.deviceCache = {};
		this.stateCache = {};
		this.deviceCacheChange = new EventEmitter<boolean>();
		this.stateCacheChange = new EventEmitter<boolean>();
		this.settingsChange = new EventEmitter<boolean>();
	}
}

@Component({
	selector: 'custom-snmp-monitor',
	templateUrl: './customsnmpmonitor.component.html',
	styleUrls: ['./customsnmpmonitor.component.scss']
})
export class CustomSnmpMonitorComponent extends MonitorEditorComponentBase {

    @ViewChild(CustomSnmpSettingsComponent, { static: true })
	public customSnmpSetsComponent: CustomSnmpSettingsComponent;

	@ViewChild(CustomSnmpDevicesComponent, { static: true })
	public customSnmpDevicesComponent: CustomSnmpDevicesComponent;

    @ViewChild(MonitorScheduleComponent, { static: true })
	public monSchedComponent: MonitorScheduleComponent;

    @ViewChild(MonitorEventsComponent, { static: true })
	public monEventsComponent: MonitorEventsComponent;

    @ViewChild(MonitorHistoryComponent, { static: true })
	public monHistoryComponent: MonitorHistoryComponent;

	public monEditorState: CustomSnmpMonitorComponentState;
	public activeTabIndex: number;

	constructor(monitorService: MonitorService,
		messageService: MessageService,
		identityService: IdentityService,
		navService: NavigationService,
		changeDetector: ChangeDetectorRef) {

		super(monitorService, messageService, identityService, navService, changeDetector);

		this.initMonEditorState();
		this.initActiveTabIndex();
	}

	private initMonEditorState(): void {
		this.monEditorState = new CustomSnmpMonitorComponentState();
	}

	private initActiveTabIndex(): void {
		this.activeTabIndex = 0;
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.children = [
			this.customSnmpSetsComponent,
			this.customSnmpDevicesComponent,
			this.monSchedComponent,
			this.monEventsComponent,
			this.monHistoryComponent,
		];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes["visible"] && this.visible) {
			this.initMonEditorState();
			this.initActiveTabIndex();
		}
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public get schedule(): Schedule {
		if (this.monSchedComponent)
			return this.monSchedComponent.value;
		else
			return new Schedule();
	}

	public override doSaveActions(): void {

		let output = this.policyEditor.Policy.VerifyConfig();
		console.log(output);
	}

}
